export default (element) => {
    const rect = element === null || element === void 0 ? void 0 : element.getBoundingClientRect();
    return {
        x: (rect === null || rect === void 0 ? void 0 : rect.left) || 0 + document.body.scrollLeft,
        y: (rect === null || rect === void 0 ? void 0 : rect.top) || 0 + document.body.scrollTop,
        width: (element === null || element === void 0 ? void 0 : element.offsetWidth) || 0,
        height: (element === null || element === void 0 ? void 0 : element.offsetHeight) || 0,
    };
    // return {
    //   y: element?.offsetTop || 0,
    //   x: element?.offsetLeft || 0
    // };
};
